/**
 * @generated SignedSource<<a46e0ba74dc44b9298458f8ca2d37850>>
 * @relayHash 59f2441b17d6c0179b586d389a95dd9e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c915f04c8bf53ef352a218e021c2a472f2c241d977737cb12698ee1babe411fe

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isValidationFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-improve-validation.relayprovider';
import isConditionsFGEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-journey-builder-condition-smart-value.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c915f04c8bf53ef352a218e021c2a472f2c241d977737cb12698ee1babe411fe",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderimprovevalidationrelayprovider": isValidationFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": isConditionsFGEnabled_provider
    }
  }
};

export default node;
